module.exports = __webpack_public_path__ + "static/media/FM_EU_Client_Categorisation_Policy_March_2025.1a823e8a.pdf";